import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Text, VerticalSpacing } from '../../components/Boneyard';
import { useMedia } from '@g4/boneyard/lib/Media';

import TICKETMASTER_LOGO from '../../images/ticketmaster_logo.png';

const propTypes = {
  raidersDisclaimerHeader: PropTypes.string,
  raidersDisclaimerHeaderLabel: PropTypes.string,
  raidersDisclaimerFirstBulletPointText: PropTypes.string,
  raidersDisclaimerFirstBulletPointSubText: PropTypes.string,
  raidersDisclaimerSecondBulletPointText: PropTypes.string,
  raidersDisclaimerThirdBulletPointText: PropTypes.string,
  isMobile: PropTypes.bool,
};

const defaultProps = {
  raidersDisclaimerHeaderLabel: 'Important things to remember:',
  raidersDisclaimerFirstBulletPointText:
    'Number of travelers = Number of tickets',
  raidersDisclaimerFirstBulletPointSubText:
    'You may not buy more raiders tickets than the number of qualifying passengers',
  raidersDisclaimerSecondBulletPointText:
    'Requires a Round-Trip Flight + 2 Night Minimum Hotel Stay',
  raidersDisclaimerThirdBulletPointText: 'Tickets will be sent via',
};

const TextWithLogo = styled(Text).attrs({ size: 18, color: '#ffffff' })`
  display: inline;
`;

const Logo = styled.img`
  display: inline;
  height: 18px;
`;

const BulletPoint = ({ text, subtext, logo }) => {
  const mq = useMedia();
  const isMobile = mq.lte('sm');
  const pointWidth = isMobile ? 8 : 10;

  return (
    <>
      <Box w="100%" d="flex">
        <Box
          w="8%"
          d="flex"
          alignItems="center"
          justifyContent="flex-end"
          pr={3}
        >
          <Box
            h={pointWidth}
            w={pointWidth}
            minWidth={pointWidth}
            borderRadius={pointWidth}
            backgroundColor="#797979"
          />
        </Box>
        <Box w="92%" alignItems="center" justifyContent="center">
          {logo ? (
            <>
              <TextWithLogo>{text}</TextWithLogo>
              {'  '}
              <Logo src={logo} alt="" />
            </>
          ) : (
            <Text size={18} color="#ffffff">
              {text}
            </Text>
          )}
        </Box>
      </Box>
      {subtext && (
        <Box w="100%" d="flex" alignItems="center" justifyContent="flex-end">
          <Box w="92%" alignItems="center" justifyContent="center">
            <Text size={14} color="#ffffff">
              {subtext}
            </Text>
          </Box>
        </Box>
      )}
    </>
  );
};

const Disclaimer = ({
  raidersDisclaimerHeaderLabel,
  raidersDisclaimerFirstBulletPointText,
  raidersDisclaimerFirstBulletPointSubText,
  raidersDisclaimerSecondBulletPointText,
  raidersDisclaimerThirdBulletPointText,
  isMobile,
}) => (
  <Box w={isMobile ? '100%' : '60%'} pt={5}>
    <Text size={18} weight={700} color="#ffffff">
      {raidersDisclaimerHeaderLabel}
    </Text>
    <VerticalSpacing size={9} />
    <Box d="flex" direction="column">
      <BulletPoint
        text={raidersDisclaimerFirstBulletPointText}
        subtext={raidersDisclaimerFirstBulletPointSubText}
      />
      <VerticalSpacing size={6} />
      <BulletPoint text={raidersDisclaimerSecondBulletPointText} />
      <VerticalSpacing size={6} />
      <BulletPoint
        text={raidersDisclaimerThirdBulletPointText}
        logo={TICKETMASTER_LOGO}
      />
    </Box>
  </Box>
);

Disclaimer.propTypes = propTypes;

Disclaimer.defaultProps = defaultProps;

BulletPoint.propTypes = {
  text: PropTypes.string,
  subtext: PropTypes.string,
  logo: PropTypes.string,
};

export default Disclaimer;
